<template>
  <div>
  </div>
</template>
<script>
import { Dialog } from 'vant';
import isAppBack from '@/mixin/isAppBack'
import MyAPI from '@/services/h5/my'
import API from '@/services/h5/common'

export default {
  mixins: [isAppBack],
  data() {
    return {
      productId: this.$route.query.productId,
      userId: this.$route.query.userId,
      // 从录单页面返回的标志
      backFlag: false
    }
  },
  beforeRouteEnter(to, from, next) {
    let initPath = [
      '/productOffline',
      '/joinUs',
    ]
    console.log(to)
    if (initPath.includes(from.path)) {
      next(vm => {
        vm.backFlag = true
      })
    } else {
      next()
    }
  },
  mounted() {
    if(this.backFlag) {
      this.judgeAppBack()
      return
    }
    MyAPI.personal()
      .then(res => {
        let member = res.data.data
        if(member.memberFlag && "Y" === member.memberFlag) {
          // 仅会员身份提示不能录单
          Dialog.confirm({
            message:
              '产品非互联网产品，如有投保需求请申请加入万利',
          })
          .then(() => {
            this.$router.push('/joinUs')
          })
          .catch(() => {
            this.judgeAppBack()
          })
        } else {
          // 否则跳转到产品录单页面
          let params = {
            productId: this.productId,
            userId: this.userId
          }
          API.getonlineProduct(params)
            .then(res => {
              window.location.href = `${res.data.data.productUrl}&productName=${res.data.data.productName}`
            })
            .catch((err) => {
              Dialog.alert({
                message: err.data.data,
              }).then(() => {
                this.judgeAppBack()
              });
            })
        }
      })
      .catch(err => {
        Dialog.alert({
          message: err.data.data,
        }).then(() => {
          this.judgeAppBack()
        });
      })

  },
}
</script>
